import { useTranslation as unifiedUseTranslation, useLocale, } from '@aviv-unified-frontend/runtime/i18n';
export const useI18n = (namespace) => {
    const { language } = useLocale();
    //TODO : need to add nutzungsdauer in shell tag
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { addTranslations } = unifiedUseTranslation(`app_${namespace}`);
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const brandTranslations = require(`../../public/locales/${language}/${namespace}.json`);
    // Loading new translations in the event of a change of locale
    addTranslations({
        language,
        translations: brandTranslations,
    });
};
